export const ProductsStatus = Object.freeze({
    2: { value: 'IN_DISCOUNT', label: 'En Dscto', color: 'orange' },
    1: { value: 'NEW', label: 'Nuevo', color: 'red' },
    0: { value: 'FEATURED', label: 'Destacado', color: 'green' },
})
